import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../Context/api";
import AddInvoiceForm from "./AddInvoiceForm";
import EditInvoiceForm from "./EditInvoiceForm";
import Spinner from "../Helpers/Spinner";
import { useAuth } from "../Context/AuthContext";

function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);
  const [invoiceToEdit, setInvoiceToEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const navigate = useNavigate();

  const { user } = useAuth();
  const isAdmin = user?.role === "Admin";

  const fetchInvoices = async () => {
    try {
      const response = await API.get("/invoices");
      setInvoices(response.data);
      console.log(response.data);
    } catch (err) {
      setError("Failed to fetch invoices");
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const filteredInvoices = invoices.filter((invoice) =>
    (invoice.invoiceDetails?.client || "")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const handleViewInvoice = (id) => navigate(`/invoice/${id}`);
  const handleEditInvoice = (id) => {
    setInvoiceToEdit(id);
    setIsEditModalOpen(true);
  };
  const handleDeleteClick = (id) => {
    setInvoiceToDelete(id);
    setIsDeleteModalOpen(true);
  };
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setInvoiceToDelete(null);
    setIsDeleting(false);
  };
  const handleDeleteInvoice = async () => {
    if (!invoiceToDelete) return;
    setIsDeleting(true);
    try {
      await API.delete(`/invoices/${invoiceToDelete}`);
      fetchInvoices();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete invoice.");
    } finally {
      closeDeleteModal();
    }
  };
  const handleAddInvoice = () => setIsAddModalOpen(true);
  const handleInvoiceUpdated = () => {
    fetchInvoices();
    setIsAddModalOpen(false);
    setIsEditModalOpen(false);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-red-500 text-lg">{error}</div>
      </div>
    );
  }

  return (
    // <div className="p-2 bg-gray-50 min-h-full flex flex-col w-full relative">
    //   {loading && <Spinner />}
    //   {/* Sticky Search Bar */}
    //   <div className="bg-white rounded-lg shadow-sm p-4 sticky top-0 z-10">
    //     <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
    //       <input
    //         type="text"
    //         placeholder="Search by customer..."
    //         value={searchQuery}
    //         onChange={handleSearchChange}
    //         className="w-full sm:w-80 p-2.5 bg-gray-100 border border-gray-200 rounded-md text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
    //       />

    //       <button
    //         onClick={handleAddInvoice}
    //         className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
    //       >
    //         Add Invoice
    //       </button>
    //     </div>
    //   </div>

    //   {/* Cards for Small Screens (Immediately After Search Bar) */}
    //   <div className="sm:hidden space-y-2">
    //     {filteredInvoices.map((invoice) => (
    //       <div
    //         key={invoice.invoiceDetails.invoiceID}
    //         className="bg-white rounded-lg shadow-sm p-4 flex flex-col gap-3 hover:shadow-md transition-shadow duration-200"
    //       >
    //         <div className="flex flex-col gap-2">
    //           <div className="flex justify-between items-start">
    //             <span className="text-sm font-semibold text-gray-600">
    //               Invoice No
    //             </span>
    //             <span className="text-sm text-gray-700 break-words">
    //               {invoice.invoiceDetails.taxInvoiceNo}
    //             </span>
    //           </div>
    //           <div className="flex justify-between items-start">
    //             <span className="text-sm font-semibold text-gray-600">
    //               Customer
    //             </span>
    //             <span className="text-sm text-gray-700 break-words">
    //               {invoice.invoiceDetails.client}
    //             </span>
    //           </div>
    //           <div className="flex justify-between items-start">
    //             <span className="text-sm font-semibold text-gray-600">
    //               Date
    //             </span>
    //             <span className="text-sm text-gray-700 break-words">
    //               {new Date(invoice.invoiceDetails.date).toLocaleDateString()}
    //             </span>
    //           </div>
    //           <div className="flex justify-between items-start">
    //             <span className="text-sm font-semibold text-gray-600">
    //               Total (UGX)
    //             </span>
    //             <span className="text-sm text-gray-700 break-words">
    //               {invoice.invoiceDetails.totalAmount.toLocaleString()}
    //             </span>
    //           </div>
    //         </div>
    //         <div className="flex flex-col gap-2 justify-start">
    //           <button
    //             onClick={() =>
    //               handleViewInvoice(invoice.invoiceDetails.invoiceID)
    //             }
    //             className="flex-1 px-2 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm"
    //           >
    //             View
    //           </button>
    //           <button
    //             onClick={() =>
    //               handleEditInvoice(invoice.invoiceDetails.invoiceID)
    //             }
    //             className="flex-1 px-2 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm font-medium transition-all duration-200 shadow-sm"
    //           >
    //             Edit
    //           </button>
    //           <div>
    //             {isAdmin && (
    //               <>
    //                 <button
    //                   onClick={() =>
    //                     handleDeleteClick(invoice.invoiceDetails.invoiceID)
    //                   }
    //                   className="flex-1 px-2 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 text-sm font-medium transition-all duration-200 shadow-sm"
    //                   disabled={
    //                     isDeleting &&
    //                     invoiceToDelete === invoice.invoiceDetails.invoiceID
    //                   }
    //                 >
    //                   {isDeleting &&
    //                   invoiceToDelete === invoice.invoiceDetails.invoiceID
    //                     ? "Deleting..."
    //                     : "Delete"}
    //                 </button>
    //               </>
    //             )}
    //           </div>
    //         </div>
    //       </div>
    //     ))}
    //   </div>

    //   {/* Scrollable Content for Desktop */}
    //   <div className="flex-1 overflow-y-auto mt-4">
    //     {/* Table for Desktop */}
    //     <div className="hidden sm:block bg-white rounded-lg shadow-sm">
    //       <table className="w-full text-left table-fixed">
    //         <thead className="bg-gray-100 sticky top-0 z-10">
    //           <tr>
    //             {[
    //               { label: "Invoice No", key: "invoice-no" },
    //               { label: "Customer", key: "customer" },
    //               { label: "Date", key: "date" },
    //               { label: "Total (UGX)", key: "total" },
    //               { label: "Actions", key: "actions" },
    //             ].map((header) => (
    //               <th
    //                 key={header.key}
    //                 className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider"
    //               >
    //                 {header.label}
    //               </th>
    //             ))}
    //           </tr>
    //         </thead>
    //         <tbody className="divide-y divide-gray-100">
    //           {filteredInvoices.map((invoice) => (
    //             <tr
    //               key={invoice.invoiceDetails.invoiceID}
    //               className="hover:bg-gray-50 transition-colors duration-150"
    //             >
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {invoice.invoiceDetails.taxInvoiceNo}
    //               </td>
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {invoice.invoiceDetails.client}
    //               </td>
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {new Date(invoice.invoiceDetails.date).toLocaleDateString()}
    //               </td>
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {invoice.invoiceDetails.totalAmount.toLocaleString()}
    //               </td>
    //               <td className="px-4 py-3 flex gap-2 flex-col justify-start items-start flex-wrap">
    //                 <button
    //                   onClick={() =>
    //                     handleViewInvoice(
    //                       invoice.invoiceDetails?.invoiceID || invoice.id
    //                     )
    //                   }
    //                   className="px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
    //                 >
    //                   View
    //                 </button>
    //                 <button
    //                   onClick={() =>
    //                     handleEditInvoice(
    //                       invoice.invoiceDetails?.invoiceID || invoice.id
    //                     )
    //                   }
    //                   className="px-3 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
    //                 >
    //                   Edit
    //                 </button>
    //                 {isAdmin && (
    //                   <button
    //                     onClick={() =>
    //                       handleDeleteClick(
    //                         invoice.invoiceDetails?.invoiceID || invoice.id
    //                       )
    //                     }
    //                     className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
    //                     disabled={
    //                       isDeleting &&
    //                       invoiceToDelete ===
    //                         (invoice.invoiceDetails?.invoiceID || invoice.id)
    //                     }
    //                   >
    //                     {isDeleting &&
    //                     invoiceToDelete ===
    //                       (invoice.invoiceDetails?.invoiceID || invoice.id)
    //                       ? "Deleting..."
    //                       : "Delete"}
    //                   </button>
    //                 )}
    //               </td>
    //               {/* <td className="px-4 py-3">
    //                 <div className="flex flex-col gap-2 justify-start">
    //                   <button
    //                     onClick={() =>
    //                       handleViewInvoice(
    //                         invoice.invoiceDetails?.invoiceID || invoice.id
    //                       )
    //                     }
    //                     className="px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
    //                   >
    //                     View
    //                   </button>
    //                   <button
    //                     onClick={() =>
    //                       handleEditInvoice(
    //                         invoice.invoiceDetails?.invoiceID || invoice.id
    //                       )
    //                     }
    //                     className="px-3 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
    //                   >
    //                     Edit
    //                   </button>
    //                   {isAdmin && (
    //                     <button
    //                       onClick={() =>
    //                         handleDeleteClick(
    //                           invoice.invoiceDetails?.invoiceID || invoice.id
    //                         )
    //                       }
    //                       className="px-3 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
    //                       disabled={
    //                         isDeleting &&
    //                         invoiceToDelete ===
    //                           (invoice.invoiceDetails?.invoiceID || invoice.id)
    //                       }
    //                     >
    //                       {isDeleting &&
    //                       invoiceToDelete ===
    //                         (invoice.invoiceDetails?.invoiceID || invoice.id)
    //                         ? "Deleting..."
    //                         : "Delete"}
    //                     </button>
    //                   )}
    //                 </div>
    //               </td> */}
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>

    //   {/* Delete Confirmation Modal */}
    //   {isDeleteModalOpen && (
    //     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    //       <div className="bg-white rounded-lg p-6 w-full max-w-md space-y-4">
    //         <h2 className="text-lg font-semibold">Confirm Deletion</h2>
    //         <p>Are you sure you want to delete this invoice?</p>
    //         <div className="flex justify-end gap-2">
    //           <button
    //             onClick={handleDeleteInvoice}
    //             className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-colors duration-200"
    //             disabled={isDeleting}
    //           >
    //             {isDeleting ? "Deleting..." : "Delete"}
    //           </button>
    //           <button
    //             onClick={closeDeleteModal}
    //             className="bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-colors duration-200"
    //             disabled={isDeleting}
    //           >
    //             Cancel
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )}

    //   {/* Add Invoice Modal */}
    //   {isAddModalOpen && (
    //     <AddInvoiceForm
    //       setIsModalOpen={setIsAddModalOpen}
    //       onInvoiceUpdated={handleInvoiceUpdated}
    //     />
    //   )}

    //   {/* Edit Invoice Modal */}
    //   {isEditModalOpen && (
    //     <EditInvoiceForm
    //       id={invoiceToEdit}
    //       setIsModalOpen={setIsEditModalOpen}
    //       onInvoiceUpdated={handleInvoiceUpdated}
    //     />
    //   )}
    // </div>

    <div className="h-full flex flex-col">
      {/* Static Header */}
      <h3 className="text-xl font-semibold mb-2 text-gray-900">Invoices</h3>

      <div className="py-2 mb-4 flex items-center justify-between gap-4 flex-wrap">
        <input
          type="text"
          placeholder="Search by customer..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full sm:w-80 p-2.5 bg-gray-100 border border-gray-200 rounded-md text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
        />

        <button
          onClick={handleAddInvoice}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
        >
          Add Invoice
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto space-y-3">
        <div className="hidden sm:block bg-white rounded-lg shadow-sm">
          <table className="w-full text-left table-fixed">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                {[
                  { label: "Invoice No", key: "invoice-no" },
                  { label: "Customer", key: "customer" },
                  { label: "Date", key: "date" },
                  { label: "Total (UGX)", key: "total" },
                  { label: "Actions", key: "actions" },
                ].map((header) => (
                  <th
                    key={header.key}
                    className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            {/* Changed divide-gray-100 to divide-gray-300 for more visible dividers */}
            <tbody className="divide-y divide-gray-300">
              {/* Added 'index' to the map function for striped rows */}
              {filteredInvoices.map((invoice, index) => (
                <tr
                  key={invoice.invoiceDetails.invoiceID}
                  // Added conditional background class for striped rows
                  className={`hover:bg-gray-50 transition-colors duration-150 ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    <span
                      className=" hover:underline cursor-pointer"
                      onClick={() =>
                        handleViewInvoice(invoice.invoiceDetails.invoiceID)
                      }
                    >
                      {invoice.invoiceDetails.taxInvoiceNo}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {invoice.invoiceDetails.client}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {new Date(invoice.invoiceDetails.date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {invoice.invoiceDetails.totalAmount.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
                    {/* <button
                      onClick={() =>
                        handleViewInvoice(
                          invoice.invoiceDetails?.invoiceID || invoice.id
                        )
                      }
                      className="bg-blue-600 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
                    >
                      View
                    </button> */}
                    <button
                      onClick={() =>
                        handleEditInvoice(
                          invoice.invoiceDetails?.invoiceID || invoice.id
                        )
                      }
                      className="bg-blue-600 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
                    >
                      Edit
                    </button>
                    {isAdmin && (
                      <button
                        onClick={() =>
                          handleDeleteClick(
                            invoice.invoiceDetails?.invoiceID || invoice.id
                          )
                        }
                        className="bg-rose-600 text-white w-20 px-3 py-1 rounded-md hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-opacity-50 transition-all duration-200"
                        disabled={
                          isDeleting &&
                          invoiceToDelete ===
                            (invoice.invoiceDetails?.invoiceID || invoice.id)
                        }
                      >
                        {isDeleting &&
                        invoiceToDelete ===
                          (invoice.invoiceDetails?.invoiceID || invoice.id)
                          ? "Deleting..."
                          : "Delete"}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards for Small Screens (Immediately After Search Bar) */}
        <div className="sm:hidden space-y-2">
          {filteredInvoices.map((invoice) => (
            <div
              key={invoice.invoiceDetails.invoiceID}
              className="bg-white rounded-lg shadow-sm p-4 flex flex-col gap-3 hover:shadow-md transition-shadow duration-200"
            >
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-600">
                    Invoice No
                  </span>
                  <span
                    className="text-sm text-gray-700 break-words hover:underline cursor-pointer"
                    onClick={() =>
                      handleViewInvoice(invoice.invoiceDetails.invoiceID)
                    }
                  >
                    {invoice.invoiceDetails.taxInvoiceNo}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-600">
                    Customer
                  </span>
                  <span className="text-sm text-gray-700 break-words">
                    {invoice.invoiceDetails.client}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-600">
                    Date
                  </span>
                  <span className="text-sm text-gray-700 break-words">
                    {new Date(invoice.invoiceDetails.date).toLocaleDateString()}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-600">
                    Total (UGX)
                  </span>
                  <span className="text-sm text-gray-700 break-words">
                    {invoice.invoiceDetails.totalAmount.toLocaleString()}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2 justify-start">
                <>
                  {/* <button
                    onClick={() =>
                      handleViewInvoice(invoice.invoiceDetails.invoiceID)
                    }
                    className="flex-1 px-2 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm"
                  >
                    View
                  </button> */}
                  <button
                    onClick={() =>
                      handleEditInvoice(invoice.invoiceDetails.invoiceID)
                    }
                    className="flex-1 px-2 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm font-medium transition-all duration-200 shadow-sm"
                  >
                    Edit
                  </button>

                  {isAdmin && (
                    <button
                      onClick={() =>
                        handleDeleteClick(invoice.invoiceDetails.invoiceID)
                      }
                      className="flex-1 px-2 py-2 bg-rose-600 text-white rounded-md hover:bg-rose-700 text-sm font-medium transition-all duration-200 shadow-sm"
                      disabled={
                        isDeleting &&
                        invoiceToDelete === invoice.invoiceDetails.invoiceID
                      }
                    >
                      {isDeleting &&
                      invoiceToDelete === invoice.invoiceDetails.invoiceID
                        ? "Deleting..."
                        : "Delete"}
                    </button>
                  )}
                </>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md space-y-4">
            <h2 className="text-lg font-semibold">Confirm Deletion</h2>
            <p>Are you sure you want to delete this invoice?</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={handleDeleteInvoice}
                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-colors duration-200"
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
              <button
                onClick={closeDeleteModal}
                className="bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-colors duration-200"
                disabled={isDeleting}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Invoice Modal */}
      {isAddModalOpen && (
        <AddInvoiceForm
          setIsModalOpen={setIsAddModalOpen}
          onInvoiceUpdated={handleInvoiceUpdated}
        />
      )}

      {/* Edit Invoice Modal */}
      {isEditModalOpen && (
        <EditInvoiceForm
          id={invoiceToEdit}
          setIsModalOpen={setIsEditModalOpen}
          onInvoiceUpdated={handleInvoiceUpdated}
        />
      )}
    </div>
  );
}

export default Invoices;
